import { StyleSheet } from "react-native";
import { family } from "../../common";
import { mobilBrower } from "../../common/helpers";

export const styles = StyleSheet.create({
    mainView: {
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center"
    },
    innerView: {
        backgroundColor: "#F1F1F1",
        borderRadius: 30,
        width: !mobilBrower() ? "40%" : "90%",
        alignItems: "center",
        padding: "6%",
        shadowColor: "white",
        shadowOffset: { width: 0, height: 0.5 },
        shadowOpacity: 0.4,
        shadowRadius: 5,
        elevation: 12,
        justifyContent: "center",
    },
    title: {
        fontSize: 18,
        textAlign: "center",
        fontFamily: family.bold,
        color: "#030135",
    },
    description: {
        fontSize: 14,
        textAlign: "center",
        fontFamily: family.effra,
        width: "80%",
        marginVertical: "7%",
        color: "#030135",
    },
    btn: {
        paddingVertical: 8,
        marginTop: 5,
        width: "80%"
    },
    btnText: {
        padding: 5,
        paddingLeft: 7,
        fontFamily: family.semibold,
        textAlign: "center",
        color: "#030135",
        paddingRight: 7,
    },
});
